import React from 'react'

type Props = {
  notes: string[]
}
export const ContentNotes: React.VFC<Props> = (props) => {
  if (props.notes.length === 0) {
    return null
  }
  return <ul className="notes">
    {
      props.notes.map((note, index) => {
        // TODO 暫定機能
        const note_array = note.split(/\n/)
        const main = note_array.shift()
        // 改行区切りで残りがなくなったらそのまま返す
        if (note_array.length === 0) {
          return <li className={`note0${index + 1}`} key={index} dangerouslySetInnerHTML={{__html: note}}/>
        }
        // 改行区切りで残りがあれば、それはコメントとして追加情報を残す
        return <li className={`note0${index + 1}`} key={index}>
          <span dangerouslySetInnerHTML={{__html: main ?? ''}}/>
          <ul className="note-comment">
            {
              note_array.map((item, i) => {
                return <li className="note-comment-list"
                           key={`note-comment${index}-${i}`}
                           dangerouslySetInnerHTML={{__html: item}}/>
              })
            }
          </ul>
        </li>
      })
    }
  </ul>
}
